import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const MobileFirstDesign = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          // Give the line a CSS gradient based on scroll position
          progress = 3000 - progress * 1.6;
    
          // Update the SVG element with the new stroke-dashoffset
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);
    
        // Remove the event listener when the component unmounts
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, // Ensures the animation occurs only once
        threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/uiux-5.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                  <h1 id="heading_line">Mobile-First Design: Enhancing User Experience on Every Device</h1>
                  <h2 id="sub_heading1">
                  At Codeflix, we specialize in Mobile-First Design, ensuring that digital experiences are optimized for mobile devices before scaling up to larger screens. With the majority of users accessing websites and applications via smartphones, a mobile-first approach enhances usability, improves performance, and boosts engagement across all platforms. Our expert designers and developers create responsive, intuitive, and high-performing interfaces tailored for the modern mobile user.
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="why_coustom_app">
            <div className="wrapper">
              <h3>
              Why Choose <span>Mobile-First Design ?</span>
              </h3>
                <p>A Mobile-First Design strategy prioritizes mobile users by designing for smaller screens first and then expanding the experience for desktops and tablets. This approach ensures faster load times, better readability, and an overall seamless experience. Key benefits include:</p>
                <ul>
                    <li><b>Improved User Experience</b>Optimized layouts, intuitive navigation, and touch-friendly interactions enhance usability.</li>
                    <li><b>Faster Performance </b>Lightweight designs and optimized assets reduce load times, keeping users engaged.</li>
                    <li><b>Higher Search Engine Rankings </b>Google prioritizes mobile-friendly websites, leading to better SEO performance.</li>
                    <li><b>Increased Conversion Rates</b>Mobile-first designs simplify actions like sign-ups, purchases, and form submissions, improving conversions.</li>
                    <li><b>Future-Proofing </b>With mobile usage continuing to grow, a mobile-first approach ensures adaptability to emerging devices and screen sizes.</li>
                </ul>
                <h3><span>Our Mobile-First Design Process</span></h3>
                <h4>1. Research & Strategy</h4>
                <p>We start with an in-depth analysis of your target audience, user behavior, and industry trends. By understanding how users interact with your site or app on mobile devices, we create a data-driven strategy that aligns with your business goals.</p>
                <h4>2. Wireframing & Prototyping</h4>
                <p>Before diving into development, we create wireframes and prototypes that outline key functionalities and user flows. These interactive blueprints allow for early feedback and ensure a seamless user experience from the start.</p>
                <h4>3. UI/UX Design & Development</h4>
                <p>Our design team focuses on minimalistic, clean, and intuitive interfaces that enhance mobile usability. Using progressive enhancement, we build from mobile-first and gradually scale up for larger screens, ensuring consistency and efficiency across all devices.</p>
                <h4>4. Performance Optimization</h4>
                <p>Speed is crucial for mobile users. We optimize assets, compress images, and use lazy loading and caching techniques to ensure lightning-fast page loads. Our goal is to enhance both performance and accessibility to reach a broader audience.</p>
                <h4>5. Testing & Refinement</h4>
                <p>We conduct extensive testing on various devices, screen sizes, and operating systems to ensure a flawless experience. Our usability tests and A/B testing help refine designs and optimize conversion paths.</p>
                <h3><span>Tools & Technologies We Use</span></h3>
                <p>Our Mobile-First Design process leverages industry-leading tools and frameworks, including:</p>
                <ul>
                    <li><b>Figma & Adobe XD </b>For UI/UX design and prototyping.</li>
                    <li><b>HTML5, CSS3 & JavaScript </b>Ensuring responsive and adaptive designs.</li>
                    <li><b>Bootstrap & Tailwind CSS</b>Mobile-first frameworks for efficient development.</li>
                    <li><b>Google Lighthouse & PageSpeed Insights </b>For performance optimization and testing.</li>
                </ul>
                <h3><span>Industries We Serve</span></h3>
                <p>We provide Mobile-First Design Services for a wide range of industries, including:</p>
                <ul>
                    <li><b>E-commerce & Retail </b>Ensuring a seamless shopping experience on mobile devices.</li>
                    <li><b>Healthcare & Telemedicine </b>Creating mobile-friendly portals for patients and providers.</li>
                    <li><b>Finance & FinTech </b>Optimizing digital banking and investment platforms.</li>
                    <li><b>Education & E-learning </b>Developing engaging mobile-first learning platforms.</li>
                    <li><b>SaaS & Technology </b>Designing scalable, high-performance applications for tech companies.</li>
                </ul>
                <h3><span>Get Started with Us!</span></h3>

<p>A Mobile-First Design approach ensures your digital presence is optimized for today’s users and tomorrow’s trends. At Codeflix, we are dedicated to crafting fast, responsive, and visually appealing mobile experiences that drive engagement and conversions. Whether you need a new mobile-first website or an upgrade to your existing platform, we are here to help. Contact us today at info@codeflixweb.com to start your mobile-first journey!</p>



            </div>
            
          </div>
          <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
                  </div>
                <div className="let_build">
                    <div className="wrapper">
                    <h4>Let’s Build <span> Your App Together </span></h4>
                  
                  <p>
                    Whether you’re a startup looking to disrupt the market or an
                    established enterprise aiming to enhance operational efficiency,
                    CodeFlix is here to bring your vision to life. Let’s create a
                    custom mobile app that drives results and delights your users.{" "}
                    <br />
                    Contact Us today to get started on your mobile app development
                    journey.
                  </p>
                    </div>
                </div>
        </>
      );
};
export default MobileFirstDesign;
